import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import GridItem from '@/components/material-ui-kit/components/Grid/GridItem';
import Card from '@/components/material-ui-kit/components/Card/Card';
import CardAvatar from '@/components/material-ui-kit/components/Card/CardAvatar';
import styles from 'styles/jss/original/components/menus/detailAuthor';
import { IMenu } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  menu: IMenu;
};

const DetailAuthor: React.FC<ComponentProps> = ({ menu }) => {
  const classes = useStyles();
  const { relationAuthor } = menu.fields;

  if (!relationAuthor) return null;
  return (
    <div className={classes.section}>
      <hr />
      <Card plain profile className={classes.card}>
        <GridContainer>
          {/* @ts-expect-error */}
          <GridItem xs={3} sm={2} md={2}>
            <CardAvatar plain profile>
              <picture>
                <source
                  srcSet={`${relationAuthor.fields.thumbnail?.fields.file.url}?fm=webp`}
                  media='(min-width: 641px)'
                />
                <source
                  srcSet={`${relationAuthor.fields.thumbnail?.fields.file.url}?fm=webp&fit=pad&w=200`}
                  media='(max-width: 640px)'
                />
                <img
                  src={`${relationAuthor.fields.thumbnail?.fields.file.url}?fit=pad&w=200`}
                  alt={relationAuthor.fields.title}
                />
              </picture>
            </CardAvatar>
          </GridItem>
          {/* @ts-expect-error */}
          <GridItem xs={9} sm={10} md={10}>
            <h4 className={classes.cardTitle}>{relationAuthor.fields.title}</h4>
            <p className={classes.description}>{relationAuthor.fields.desc}</p>
          </GridItem>
        </GridContainer>
      </Card>
      <hr />
    </div>
  );
};

export default DetailAuthor;
